export default {
  sections: {
    settings: 'Asetukset',
  },
  status_switch: {
    label: 'Kanta-asiakasohjelma',
    on: 'Päällä',
    off: 'Pois',
    description: 'Asiakkaat saavat käteispalautusta jokaisesta tilauksesta ja voivat käyttää sen kassalla.',
    description_missing: 'Tallenna alla olevat asetukset käynnistääksesi kanta-asiakasohjelman.',
  },
  alerts: {
    off: 'Kanta-asiakasohjelmasi on pois päältä. Asiakkaat eivät saa käteispalautusta uusista tilauksista, eivät voi käyttää pisteitään eivätkä näe ohjelmaa kaupassasi. Jo kerätyt pisteet säilyvät ja vanhenevat normaalisti.',
    expired: 'Kanta-asiakasohjelmasi on päättynyt. Käynnistä se uudelleen ilman päättymispäivää.',
  },
  form: {
    title: {
      label: 'Otsikko',
    },
    percentage: {
      label: 'Käteispalautusprosentti',
      validation: {
        required: 'Käteispalautusprosentti on pakollinen',
        min: 'Käteispalautusprosentin vähimmäisarvo on {{value}} %',
        max: 'Käteispalautusprosentin enimmäisarvo on {{value}} %',
      },
    },
    point_lifetime: {
      label: 'Kuinka monta päivää annat asiakkaillesi aikaa käyttää pisteet?',
      validation: {
        min: 'Pisteiden vanhenemisaika vähintään {{value}} päivää',
      },
    },
    min_spending_limit: {
      label: 'Käteispalautuksen vähimmäisostoraja',
      validation: {
        required: 'Vähimmäisostoraja on pakollinen',
        gt_zero: 'Vähimmäisostorajan on oltava suurempi kuin 0',
        lt_max_spending_limit: 'Vähimmäisostorajan on oltava pienempi kuin enimmäisostoraja',
      },
    },
    max_spending_limit: {
      label: 'Käteispalautuksen enimmäisostoraja',
      validation: {
        required: 'Enimmäisostoraja on pakollinen',
        gt_min_spending_limit: 'Enimmäisostorajan on oltava suurempi kuin vähimmäisostoraja',
      },
    },
    has_welcome_bonus: {
      label: 'Tervetuliaisbonus',
      description: 'Anna ensikertalaisille kirjautumisbonuksena käteispalautusta',
    },
    welcome_bonus: {
      label: 'Tervetuliaisbonuksen arvo',
    },
    has_end_date: {
      label: 'Kesto',
      options: {
        false: 'Rajoittamaton',
        true: 'Tietyllä päättymispäivällä',
      },
    },
    end_date: {
      label: 'Päättymispäivä',
    },
    has_mobile_app_signup_bonus: {
      label: 'Mobiilisovelluksen rekisteröitymisbonus',
      description: 'Palkitse käyttäjät, jotka kirjautuvat mobiilisovellukseen ensimmäistä kertaa',
    },
    mobile_app_signup_bonus: {
      label: 'Bonuksen määrä',
    },
  },
  tags: {
    inactive: 'Ei aktiivinen',
    active: 'Aktiivinen',
    expired: 'Vanhentunut',
  },
  buttons: {
    save: 'Tallenna',
  },
  toasts: {
    changes_got_saved: 'Muutokset tallennettu',
    failed_to_save_changes: 'Muutosten tallentaminen epäonnistui',
    turned_on: 'Kanta-asiakasohjelma otettu käyttöön',
    turned_off: 'Kanta-asiakasohjelma poistettu käytöstä',
  },
};
